<div *ngIf="vacantTaxAdjustment">
	<form #form="ngForm" class="w-full flex flex-row" (ngSubmit)="submit(form)">
		<div class="w-1/2 mr-5">
			<h2>Vacant home tax</h2>
			<div class="flex flex-col mt-5">
				<app-input
					name="adjustmentTitle"
					label="Adjustment title"
					required
					[(ngModel)]="vacantTaxAdjustment.title"
				></app-input>

				<div class="flex flex-col">
					<app-input
						name="propertyValue"
						class="mt-3"
						type="cents"
						required
						label="Assessed value of the property"
						[(ngModel)]="vacantTaxAdjustment.propertyValue"
						(ngModelChange)="changed()"
						[startIcon]="ICON.DOLLAR"
					></app-input>
					<div class="flex justify-end">
						<p
							class="text-green underline cursor-pointer"
							(click)="setPurchasePrice()"
							*ngIf="vacantTaxAdjustment.propertyValue != price"
						>
							Set to sale price {{ price | centsToDollars }}
						</p>
					</div>
				</div>

				<app-input
					name="vht"
					required
					class="mt-3"
					type="percentage"
					label="Vacant home tax rate"
					[(ngModel)]="vhtRate"
					(ngModelChange)="changed()"
					[startIcon]="ICON.PERCENTAGE"
					textAlign="right"
					decimalValues="4"
				></app-input>

				<div *ngIf="primaryJurisdiction" class="flex mt-3">
					Jurisdiction:
					@if (vhtLink) {
						<app-anchor
							class="ml-1"
							[icon]="ICON.EXTERNAL"
							[external]="true"
							label="test"
							url="{{ vhtLink }}"
							>{{ jurisdictionName }}</app-anchor
						>
					} @else {
						{{ jurisdictionName }}
					}
				</div>

				<app-input
					name="taxAmount"
					required
					disabled
					class="mt-3"
					type="cents"
					label="Vacant home tax amount"
					[ngModel]="taxAmount"
					[startIcon]="ICON.DOLLAR"
				></app-input>

				<app-input
					name="interests"
					required
					class="mt-3"
					type="cents"
					label="Interest on unpaid tax"
					[(ngModel)]="vacantTaxAdjustment.interestOnUnpaidTax"
					(ngModelChange)="changed()"
					[startIcon]="ICON.DOLLAR"
				></app-input>

				<app-input
					name="filingPenalty"
					required
					class="mt-3"
					type="cents"
					label="Missed or false filing penalty"
					[(ngModel)]="vacantTaxAdjustment.filingPenalty"
					(ngModelChange)="changed()"
					[startIcon]="ICON.DOLLAR"
				></app-input>

				<div class="mt-5">
					<app-checkbox
						name="applyHst"
						type="clear"
						label="Apply HST (13%)"
						[(ngModel)]="vacantTaxAdjustment.applyHst"
						(ngModelChange)="changed()"
					></app-checkbox>
				</div>

				<div class="mt-5">
					<app-checkbox
						name="includeDetails"
						type="clear"
						label="Include all details in document"
						[(ngModel)]="vacantTaxAdjustment.details"
					></app-checkbox>
				</div>

				<div class="flex justify-between mt-5">
					<app-button btn="secondary" (click)="close()">Cancel</app-button>

					<app-button type="submit" btn="primary">Save</app-button>
				</div>
			</div>
		</div>

		<div class="w-1/2">
			<app-container type="dark" title="Details">
				<div class="flex flex-1 flex-col">
					<div class="mb-8">
						<div class="flex justify-between mb-3">
							<div>Assessed property value</div>
							<div>
								{{ vacantTaxAdjustment.propertyValue | centsToDollars }}
							</div>
						</div>

						<div class="flex justify-between mb-3">
							<div>VHT amount at {{ vhtRate }}% tax rate</div>
							<div>
								{{ taxAmount | centsToDollars }}
							</div>
						</div>

						<div
							*ngIf="vacantTaxAdjustment.interestOnUnpaidTax"
							class="flex justify-between mb-3"
						>
							<div>Interest on unpaid tax</div>
							<div>
								{{ vacantTaxAdjustment.interestOnUnpaidTax | centsToDollars }}
							</div>
						</div>

						<div
							*ngIf="vacantTaxAdjustment.filingPenalty"
							class="flex justify-between mb-3"
						>
							<div>Missed or false filing penalty</div>
							<div>
								{{ vacantTaxAdjustment.filingPenalty | centsToDollars }}
							</div>
						</div>

						<div
							*ngIf="vacantTaxAdjustment.applyHst"
							class="flex justify-between mb-3"
						>
							<div>HST calculated at {{ matterHst | percent }}</div>
							<div>
								{{ hstAmount | centsToDollars }}
							</div>
						</div>

						<div class="flex justify-end items-start mb-3">
							<div>
								<strong>Total = {{ total | centsToDollars }}</strong>
							</div>
						</div>
					</div>
				</div>
			</app-container>
		</div>
	</form>
</div>
